import React from "react";
import styles from "../OurBrands/OurBrands.module.scss"; // Import the custom CSS file
import OurBrandImage from "../../../assets/images/our brands.png";
import ImageTextSection from "../../CustomComponent/ImageTextSection.tsx";

const OurBrands: React.FC = () => {
 
  // const content = [
  //   `Aptech is a trusted leader in vocational training and global learning solutions, offering specialised training programs that empower individuals with industry-relevant expertise. Our comprehensive courses are designed to provide some of the best career opportunities across various sectors, including IT, aviation, hospitality, and more. Our diverse verticals, under International Retail, include:`,
  // ];

  return (
    <div id="OurBrands" className={styles.OurBrands}>
      <div className="container">
        <div className="subSection">
        <div className="row">
          <div className="col-12 d-flex flex-column justify-content-center align-items-center">
            <p className="heading">OUR businesses</p>
            <p className={`${styles.businessPara} para text-center mb-0`}>Aptech is a trusted leader in vocational training and global learning solutions, offering specialised training programs that empower individuals with industry-relevant expertise. Our comprehensive courses are designed to provide some of the best career opportunities across various sectors, including <strong>animation, VFX, IT, aviation, hospitality, beauty and wellness</strong> and more.</p>
            {/* <ImageTextSection
              imageSrc={OurBrandImage}
              imageAlt="Our brand Image"
              content={content}
              reverse={true}
              heading="OUR businesses"
              imageHeight={'25rem'}
              imageHeightTablet={`25rem`}
              

            /> */}
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default OurBrands;
